import { classnames } from '@bem-react/classnames';
import { withBemMod } from '@bem-react/core';
import { useComponentRegistry } from '@bem-react/di';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelCta } from 'client/common/types';
import { reachGoal } from 'utils/metrika';

import { cnLevel, ILevelProps } from '..';

import './level_type_cta.css';

export interface ILevelTypeCtaProps extends Omit<ILevelCta, 'type'> {
    type?: 'cta';
}

export const withLevelTypeCta = withBemMod<ILevelTypeCtaProps, ILevelProps>(
    cnLevel(),
    { type: 'cta' },
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { blocks, className, ...otherProps } = props;

        const { Button } = useComponentRegistry('lego');

        const levelClass =
            blocks.length === 2
                ? classnames(className, cnLevel({ size: 2 }))
                : className;

        return (
            <BaseLevel className={levelClass} {...otherProps}>
                <>
                    {blocks.map(({
                        title,
                        description,
                        buttonText,
                        buttonUrl,
                        metrikaGoalId
                    }) => {
                        return (
                            <div key={title} className={cnLevel('block')}>
                                <h3
                                    className={cnLevel('title')}
                                    dangerouslySetInnerHTML={{ __html: title }}
                                    />
                                {description && (
                                <HtmlContent
                                    className={cnLevel('description')}
                                    content={description}
                                    />
                                )}
                                <Button
                                    className={cnLevel('button')}
                                    theme="action"
                                    view="classic"
                                    size="m"
                                    type="link"
                                    url={buttonUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => metrikaGoalId && reachGoal(metrikaGoalId)}
                                    >
                                    {buttonText}
                                </Button>
                            </div>
                        );
                    })}
                </>
            </BaseLevel>
        );
    }
);
